module.exports = __webpack_public_path__ + "static/img/center_logo.ee5128e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gaoBaoBan/center_logo.png
// module id = w2Hk
// module chunks = 39